<template>
    <div class="shop">
        <div class="screen">
            <div>
                <div>所有产品</div>
                <div :class="isOpen?'open':'stow'">
                    <div v-for="(item,key) in productList" :key="key" :class="product==item.name?'blue':''"
                        @click="screenProduct(item)">{{item.name}}</div>
                </div>
                <div @click="openOrStow">
                    更多<i v-if="isOpen" class="el-icon-arrow-up"></i><i v-else class="el-icon-arrow-down"></i>
                </div>
            </div>
            <div>
                <div>交货方式</div>
                <div>
                    <div @click="screenDeliveryMethod(1)" :class="deliveryMethod=='1'?'blue':''">自提</div>
                    <div @click="screenDeliveryMethod(2)" :class="deliveryMethod=='2'?'blue':''">派送</div>
                </div>
            </div>
            <!-- <div>
                <div>交货地</div>
                <div>
                    <div>点选交货地</div>
                </div>
            </div> -->
            <div>
                <div>状态</div>
                <div v-if="shopType=='B'">
                    <div @click="screenStatus('0')" :class="status=='0'?'blue':''">即将开始</div>
                    <div @click="screenStatus('1')" :class="status=='1'?'blue':''">进行中</div>
                    <div @click="screenStatus('2')" :class="status=='2'?'blue':''">已结束</div>
                </div>
                <div v-if="shopType=='YXMH'">
                    <div @click="screenStatus('1')" :class="status=='1'?'blue':''">进行中</div>
                    <div @click="screenStatus('0')" :class="status=='0'?'blue':''">停售中</div>
                    <div @click="screenStatus('2')" :class="status=='2'?'blue':''">已结束</div>
                </div>
            </div>
        </div>
        <div class="list">
            <div class="item_3" v-for="(commodity,index) in list" :key="index" @click="goDetails(commodity)">
                <div>
                    <div v-if="commodity.typeName=='抢购'" :class="'status_'+commodity.status">
                        <span v-if="commodity.status=='0'">即将开始</span>
                        <span v-if="commodity.status=='1'">进行中</span>
                        <span v-if="commodity.status=='2'">已结束</span>
                    </div>
                    <div v-if="commodity.typeName=='意向卖货'"
                        :class="commodity.status=='1'?'status_1':commodity.status=='2'?'status_0':'status_2'">
                        <span v-if="commodity.status=='1'">进行中</span>
                        <span v-if="commodity.status=='2'">停售中</span>
                        <span v-if="commodity.status=='3'">已结束</span>
                    </div>
                    <div class="ellipsis">{{commodity.title}}{{commodity.productMsg?'·'+commodity.productMsg:''}}</div>
                    <div>
                        <div><i class=""></i>总量<span class="blue">{{commodity.amount}}</span>{{commodity.numUnit}}</div>
                        <!-- <div>最低购买量<span class="blue">25</span>{{commodity.numUnit}}</div> -->
                    </div>
                    <div><i class="iconC el-icon-office-building"></i> {{$store.state.orgName}}</div>
                    <div><i class="iconC el-icon-time"></i> {{shopType=='B'?'开始时间':'更新时间'}}
                        {{commodity.startDate|homeTime}}</div>
                </div>
                <div class="auction" v-if="shopType=='B'">
                    <div>
                        <span class="red fz22">¥</span>
                        <span
                            class="red fz32">{{commodity.modeName=='明拍'?(commodity.priceOneNew?commodity.priceOneNew/1:commodity.priceOne/1):(commodity.isPublic=='2'?'???':commodity.status=='2'?(commodity.priceOneNew?commodity.priceOneNew/1:commodity.priceOne/1):'???')}}</span>
                        （当前最高价）
                    </div>
                    <div>
                        竞拍底价
                        <span
                            class="green fz20">¥{{commodity.modeName=='明拍'?commodity.priceOne/1:(commodity.status=='2'?commodity.priceOne/1:'???')}}</span>
                        / {{commodity.unitedTitle}}
                    </div>
                    <div class="btn">立即竞拍</div>
                </div>
                <div class="yxmh" v-if="shopType=='YXMH'">
                    <div>
                        <label v-if="commodity.priceOne/1!=0">底价</label>
                        <span class="origin fz22 fwB" v-if="commodity.priceOne/1!=0">¥</span>
                        <span class="origin fz32 fwB">{{commodity.priceOne/1==0?'面议':commodity.priceOne/1}}</span>
                    </div>
                    <div class="btn">立即购买</div>
                </div>
            </div>
        </div>
        <div class="page">
            <el-pagination @current-change="handleCurrentChange" background :current-page="pageNum" :page-size="12"
                layout="prev, pager, next" :total="total">
            </el-pagination>
            <input type="text" name="" id="" v-model="num" />
            <el-button size="mini" style="margin-left: 16px;" @click="inputCurrentChange">跳转</el-button>
        </div>
    </div>
</template>

<script>
    import bus from '../../tools/bus.js'
    export default {
        name: "Shop",
        data() {
            return {
                isOpen: false,

                product: null,
                status: null,
                deliveryMethod: null,

                list: [],
                productList: [],

                pageNum: 1,
                num: null,
                total: 0,

                shopType: null
            }
        },
        watch: {
            $route: {
                handler: 'init'
            }
        },
        mounted() {
            let that = this;
            that.init();
            bus.$on('search', data => {
                that.product = data.keyWord;
                that.pageNum = 1;
                that.getList();
            })
        },
        methods: {
            goDetails(commodity) {
                let that = this;
                commodity.showType = commodity.typeName;
                commodity.biddingMode = commodity.modeName;
                commodity.pendingWay = commodity.modeName;

                if (!that.$store.state.userId) {
                    that.goRouter('/login');
                    return;
                }

                if (commodity.showType == '抢购') {
                    if (commodity.biddingMode == '明拍') {
                        if (commodity.userId == that.$store.state.userId) {
                            that.$router.push({
                                path: '/shop_jp_details_sell',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        } else {
                            that.$router.push({
                                path: '/shop_jp_details_buy',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        }
                    } else {
                        if (commodity.userId == that.$store.state.userId) {
                            that.$router.push({
                                path: '/shop_jp_details_sell',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        } else {
                            that.$router.push({
                                path: '/shop_jp_details_buy',
                                query: {
                                    commodityId: commodity.id
                                }
                            });
                        }
                    }
                }

                if (commodity.showType == '意向卖货') {
                    if (that.$store.state.userId == commodity.userId) { //卖家
                        that.$router.push({
                            path: '/shop_yxmh_details_sell',
                            query: {
                                commodityId: commodity.id
                            }
                        });
                    } else { //买家
                        this.$router.push({
                            path: '/shop_yxmh_details_buy',
                            query: {
                                commodityId: commodity.id
                            }
                        });
                    }
                }
            },
            init() {
                this.product = null;
                this.status = null;
                this.num = null;
                this.isOpen = false;
                this.list = [];
                if (this.$route.name == 'ShopAuction') {
                    this.shopType = 'B';
                }
                if (this.$route.name == 'ShopYXMH') {
                    this.shopType = 'YXMH';
                }
                this.getList();
                this.getProductList();
            },
            openOrStow() {
                this.isOpen = !this.isOpen;
            },
            screenDeliveryMethod(deliveryMethod) {
                this.deliveryMethod = deliveryMethod;
                this.pageNum = 1;
                this.getList();
            },
            screenStatus(status) {
                this.status = status;
                this.pageNum = 1;
                this.getList();
            },
            screenProduct(product) {
                this.product = product.name;
                this.pageNum = 1;
                this.getList();
            },
            inputCurrentChange() {
                if (!this.num) {
                    return;
                }
                this.pageNum = this.num / 1;
                this.getList();
            },
            handleCurrentChange(pageNum) {
                this.pageNum = pageNum;
                this.getList();
            },
            getList() {
                let params = {
                    pageNum: this.pageNum,
                    pageSize: 12,
                    brtNum: this.$store.state.orgCode,
                    type: 2,
                    dealType: this.shopType
                }
                if (this.product) {
                    params.product = this.product;
                }
                if (this.status) {
                    params.status = this.status;
                }
                if (this.status) {
                    params.deliveryMethod = this.deliveryMethod;
                }

                this.request.get(this.$store.state.httpUrl + "new/h5/queryCommodityListTradeH5", {
                    params: params
                }).then(res => {
                    if (res.status == 200) {
                        this.list = res.data;
                        this.total = res.total;
                    }
                });
            },
            getProductList() {
                // byProduct/recordList
                this.request.post(this.$store.state.httpUrl + "byProduct/recordList-ry", {
                    userId: this.$store.state.orgCode
                }).then(res => {
                    if (res.status == 200) {
                        this.productList = res.data.all;
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .shop {
        background: #FFFFFF;
    }

    .screen {
        width: 1200px;
        margin: 0 auto;
        font-size: 14px;
        border: 1px solid #CCCCCC;
        box-sizing: border-box;
        text-align: left;
    }

    .screen>div {
        display: flex;
        line-height: 48px;
        border-bottom: 1px solid #CCCCCC;
        padding-right: 24px;
        width: 100%;
        box-sizing: border-box;
    }

    .screen>div:last-child {
        border: none;
    }

    .screen>div:nth-child(1)>div:nth-child(2) {
        width: 1050px;
        flex-wrap: wrap;
    }

    .stow {
        height: 48px;
        overflow: hidden;
    }

    .open {}

    .screen>div:nth-child(1)>div:nth-child(3) {
        width: 50px;
        text-align: right;
        cursor: pointer;
    }

    .screen>div>div:nth-child(1) {
        width: 80px;
        padding-left: 24px;
        color: #999999;
    }

    .screen>div>div:nth-child(2) {
        padding-right: 24px;
        display: flex;
        color: #333333;
    }

    .screen>div>div:nth-child(2)>div {
        margin-right: 24px;
        cursor: pointer;
    }

    .screen>div>div:nth-child(2)>div:last-child {
        padding: 0;
    }

    .list {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        /* justify-content: space-between; */
        box-sizing: border-box;
        text-align: left;
    }

    .list>div {
        font-size: 14px;
        color: #666666;
        margin-top: 30px;
        margin-right: calc(88px / 3);
    }

    .list>div:nth-child(4),
    .list>div:nth-child(8),
    .list>div:nth-child(12) {
        margin-right: 0 !important;
    }

    .item_3 {
        width: 278px;
        /* height: 362px; */
        border-radius: 10px;
        box-sizing: border-box;
        padding: 0 24px;
        padding-bottom: 24px;
        border: 1px solid #ABC0EC;
    }

    .item_3>div {
        box-sizing: border-box;
    }

    .item_3>div:nth-child(1) {
        padding-top: 24px;
        height: 164px;
        border-bottom: 1px solid #CCD4E9;
        position: relative;
    }

    .item_3>div:nth-child(1)>div:nth-child(1) {
        width: 72px;
        height: 26px;
        border-radius: 13px 0px 0px 13px;
        text-align: center;
        line-height: 26px;
        font-size: 14px;
        font-weight: 500;
        box-sizing: border-box;
        position: absolute;
        right: -24px;
        top: 12px;
    }

    .status_0 {
        color: #FF8C25;
        background: #FFE3A6;
    }

    .status_1 {
        color: #729BFF;
        background: #E4EEFF;
    }

    .status_2 {
        color: #90A4D0;
        background: #E3E8F2;
    }

    .item_3>div:nth-child(1)>div:nth-child(1)>div {
        width: 72px;
        height: 26px;
        text-align: center;
    }

    .item_3>div:nth-child(1)>div:nth-child(2) {
        font-size: 20px;
        font-weight: bold;
        color: #0C306A;
    }

    .item_3>div:nth-child(1)>div:nth-child(3) {
        display: flex;
        justify-content: space-between;
        margin-top: 22px;
    }

    .item_3>div:nth-child(1)>div:nth-child(3),
    .item_3>div:nth-child(1)>div:nth-child(4),
    .item_3>div:nth-child(1)>div:nth-child(5) {
        margin-bottom: 18px;
    }

    .item_3>.auction {
        padding-top: 28px;
    }

    .item_3>.auction>div>span {
        font-weight: bold;
    }

    .item_3>.auction>div:nth-child(2) {
        margin-top: 24px;
    }

    .item_3>.auction>.btn,
    .item_3>.yxmh>.btn {
        width: 222px;
        height: 46px;
        line-height: 46px;
        margin: 0 auto;
        background: #D70606;
        border-radius: 8px;
        text-align: center;
        font-size: 16px;
        color: #FFFFFF;
        margin-top: 24px;
        cursor: pointer;
    }

    .item_3>.yxmh {
        padding-top: 24px;
    }

    .page {
        width: 1200px;
        margin: 0 auto;
        padding: 48px 0;
        display: flex;
        justify-content: center;
    }

    .page>input {
        width: 64px;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        border-radius: 6px;
        margin-left: 10px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/view/shop/shop.vue